/**
 * Subscribing to changes on dynamic properties.
 */
import { type EventHandler } from 'stores/EventDispatcher';
import type EventDispatcher from 'stores/EventDispatcher';
import { DynamicPropertyEvent } from 'types/DynamicPropertyEvent';

export function addChangeListener(
    source: EventDispatcher,
    handler: EventHandler
): () => void {
    source.addEventListener(DynamicPropertyEvent.CHANGED, handler);
    return () =>
        source.removeEventListener(DynamicPropertyEvent.CHANGED, handler);
}

const doNothing = () => {};

export function maybeAddChangeListener(
    source: EventDispatcher | undefined | null,
    handler: EventHandler
): () => void {
    return source ? addChangeListener(source, handler) : doNothing;
}
